import { notification } from "antd";

// Configuración global para notificaciones
export const openNotification = (type, message, description) => {
  notification[type]({
    message,
    description,
    placement: "topRight",
    style: {
      backgroundColor: type === "success" ? "#dff0d8" : "#f8d7da", // Verde para success, rojo para error
      border: `1px solid ${type === "success" ? "#d4edda" : "#f5c6cb"}`,
      color: type === "success" ? "#155724" : "#721c24",
    },
  });
};
